document.addEventListener('DOMContentLoaded', () => {

  const startMysticRouteBar = () => {
    if (window.MysticRouteHandoff?.start) {
      window.MysticRouteHandoff.start();
    }
  };

  const renderSearchRecommendationPills = () => {
    const source =
      document.querySelector('#SearchDrawerRecommendationsSettings');

    const targets =
      document.querySelectorAll('[data-search-recommendations-list]');

    if (!source || !targets.length) return;

    let rawQueries = '';

    try {
      rawQueries =
        JSON.parse(source.textContent || '""');
    } catch (error) {
      rawQueries = '';
    }

    const queries =
      String(rawQueries)
        .split(/\r?\n/)
        .map(query => query.trim())
        .filter(Boolean);

    const sourceKey =
      queries.join('|');

    targets.forEach(target => {
      if (target.dataset.recommendationsSource === sourceKey) return;

      target.replaceChildren();

      queries.forEach(query => {
        const pill =
          document.createElement('div');

        pill.className =
          'search-suggestion';

        pill.dataset.searchSuggestion =
          '';

        pill.textContent =
          query;

        target.appendChild(pill);
      });

      target.dataset.recommendationsSource =
        sourceKey;

      if (!target.dataset.recommendationsClickBound) {
        target.addEventListener('click', event => {
          const pill =
            event.target.closest('[data-search-suggestion]');

          if (!pill) return;

          const searchPageForm =
            document.querySelector('#SearchPageForm');

          if (!searchPageForm || !target.closest('.main-search-suggestions-wrap')) return;

          const searchPageInput =
            searchPageForm.querySelector('[name="q"]');

          if (!searchPageInput) return;

          searchPageInput.value =
            pill.textContent.trim();

          if (typeof searchPageForm.requestSubmit === 'function') {
            searchPageForm.requestSubmit();
          } else {
            searchPageForm.submit();
          }
        });

        target.dataset.recommendationsClickBound =
          'true';
      }
    });
  };

  renderSearchRecommendationPills();

  document.addEventListener(
    'shopify:section:load',
    renderSearchRecommendationPills
  );

  const input =
    document.querySelector('#SearchInput');

  let allowSearchInputFocus =
    false;

  const unlockSearchInput = () => {
    if (!input) return;

    allowSearchInputFocus =
      true;

    input.readOnly =
      false;

    input.removeAttribute('tabindex');

    input.dataset.mysticSearchGuarded =
      'false';
  };

  const focusSearchInput = () => {
    if (!input) return;

    unlockSearchInput();
    input.focus();
  };

  if (input) {
    input.addEventListener(
      'pointerdown',
      unlockSearchInput,
      {
        capture: true
      }
    );

    input.addEventListener(
      'touchstart',
      unlockSearchInput,
      {
        capture: true,
        passive: true
      }
    );

    input.addEventListener(
      'keydown',
      unlockSearchInput,
      {
        capture: true
      }
    );

    input.addEventListener(
      'focus',
      () => {
        if (!input.readOnly) return;

        if (!allowSearchInputFocus) {
          input.blur();
          return;
        }

        unlockSearchInput();
      }
    );
  }

  const category =
    document.querySelector('#SearchCategory');

const categoryWrap =
  document.querySelector('.header-search-category-wrap');

const categoryButton =
  document.querySelector('.header-search-category-button');

const categoryLabel =
  document.querySelector('.header-search-category-label');

const categoryMenu =
  document.querySelector('.header-search-category-menu');

const positionCategoryMenu = () => {

  if (
    !categoryWrap ||
    !categoryButton ||
    !categoryMenu
  ) return;

  const rect =
    categoryButton.getBoundingClientRect();

  const viewportWidth =
    window.visualViewport?.width ||
    window.innerWidth;

  const viewportHeight =
    window.visualViewport?.height ||
    window.innerHeight;

  const viewportOffsetLeft =
    window.visualViewport?.offsetLeft ||
    0;

  const edgePadding =
    16;

  categoryMenu.style.width =
    'max-content';

  categoryMenu.style.minWidth =
    `${Math.round(rect.width)}px`;

  categoryMenu.style.maxWidth =
    `${Math.round(viewportWidth - edgePadding * 2)}px`;

  categoryMenu.style.maxHeight =
    `${Math.max(
      220,
      Math.round(viewportHeight - rect.bottom - 26)
    )}px`;

  let left =
    rect.left;

  const minLeft =
    viewportOffsetLeft + edgePadding;

  const maxLeft =
    viewportOffsetLeft + viewportWidth - categoryMenu.offsetWidth - edgePadding;

  if (left < minLeft) {

    left = minLeft;

  }

  if (left > maxLeft) {

    left = maxLeft;

  }

  categoryMenu.style.left =
    `${Math.round(left)}px`;

  categoryMenu.style.top =
    `${Math.round(rect.bottom + 10)}px`;

  categoryMenu.style.transform =
    'none';

};

const closeCategoryDropdown = () => {

  if (
    !categoryWrap ||
    !categoryButton ||
    !categoryMenu
  ) return;

  categoryWrap.classList.remove(
    'is-open'
  );

  categoryMenu.classList.remove(
    'is-open'
  );

  categoryButton.setAttribute(
    'aria-expanded',
    'false'
  );

};

const openCategoryDropdown = () => {

  if (
    !categoryWrap ||
    !categoryButton ||
    !categoryMenu
  ) return;

  categoryWrap.classList.add(
    'is-open'
  );

  categoryMenu.classList.add(
    'is-open'
  );

  categoryButton.setAttribute(
    'aria-expanded',
    'true'
  );

  positionCategoryMenu();

};

const syncCategoryDropdown = () => {

  if (
    !category ||
    !categoryLabel ||
    !categoryMenu
  ) return;

  const selectedOption =
    category.options[
      category.selectedIndex
    ];

  categoryLabel.textContent =
    selectedOption?.textContent?.trim() ||
    'All';

  categoryMenu
    .querySelectorAll(
      'button[data-value]'
    )
    .forEach(button => {

      button.classList.toggle(
        'is-active',
        button.dataset.value === category.value
      );

    });

};

if (
  category &&
  categoryWrap &&
  categoryButton &&
  categoryLabel &&
  categoryMenu
) {

  if (!categoryMenu.dataset.portaled) {

    categoryMenu.dataset.portaled =
      'true';

    document.body.appendChild(
      categoryMenu
    );

  }

  syncCategoryDropdown();

  categoryButton.addEventListener(
    'click',
    event => {

      event.preventDefault();
      event.stopPropagation();

      if (
        categoryMenu.classList.contains(
          'is-open'
        )
      ) {

        closeCategoryDropdown();

      } else {

        openCategoryDropdown();

      }

    }
  );

  categoryMenu
    .querySelectorAll(
      'button[data-value]'
    )
    .forEach(button => {

      button.addEventListener(
        'click',
        event => {

          event.preventDefault();
          event.stopPropagation();

          category.value =
            button.dataset.value;

          syncCategoryDropdown();

          closeCategoryDropdown();

          categoryButton.blur();

          category.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );

          requestAnimationFrame(() => {

            const input =
              document.querySelector('#SearchInput');

            focusSearchInput();

          });

        }
      );

    });

  document.addEventListener(
    'click',
    event => {

      if (
        categoryWrap.contains(event.target) ||
        categoryMenu.contains(event.target)
      ) return;

      closeCategoryDropdown();

    }
  );

  document.addEventListener(
    'keydown',
    event => {

      if (event.key !== 'Escape') return;

      closeCategoryDropdown();

    }
  );

  let categoryMenuFrame = null;

  const queueCategoryMenuPosition = () => {

    if (
      !categoryMenu.classList.contains(
        'is-open'
      )
    ) return;

    if (categoryMenuFrame) {

      cancelAnimationFrame(
        categoryMenuFrame
      );

    }

    categoryMenuFrame =
      requestAnimationFrame(() => {

        positionCategoryMenu();

        categoryMenuFrame = null;

      });

  };

  window.addEventListener(
    'resize',
    queueCategoryMenuPosition
  );

  window.addEventListener(
    'scroll',
    event => {

      if (
        categoryMenu.classList.contains(
          'is-open'
        ) &&
        !categoryMenu.contains(
          event.target
        )
      ) {

        closeCategoryDropdown();

        return;

      }

      queueCategoryMenuPosition();

    },
    true
  );

  if (window.visualViewport) {

    window.visualViewport.addEventListener(
      'resize',
      queueCategoryMenuPosition
    );

    window.visualViewport.addEventListener(
      'scroll',
      queueCategoryMenuPosition
    );

  }

    categoryMenu.addEventListener(
    'wheel',
    event => {

      if (
        !categoryMenu.classList.contains(
          'is-open'
        )
      ) return;

      const scrollTop =
        categoryMenu.scrollTop;

      const scrollHeight =
        categoryMenu.scrollHeight;

      const height =
        categoryMenu.clientHeight;

      const delta =
        event.deltaY;

      const isAtTop =
        scrollTop <= 0;

      const isAtBottom =
        scrollTop + height >= scrollHeight - 1;

      if (
        (delta < 0 && isAtTop) ||
        (delta > 0 && isAtBottom)
      ) {

        event.preventDefault();

      }

      event.stopPropagation();

    },
    {
      passive: false
    }
  );

  window.addEventListener(
    'pageshow',
    () => {

      closeCategoryDropdown();

      categoryButton.blur();

    }
  );

}


  const results =
  document.querySelector('#PredictiveSearchResults');

const searchContent =
  document.querySelector('.search__content');

const wrapper =
  document.querySelector('.header-search-inline');

const closeButton =
  document.querySelector('.header-search-inline__close');

const updateSuggestionOverflowState = () => {
  searchContent
    ?.querySelectorAll(
      '.predictive-search-discovery > .predictive-search-suggestions.search-suggestions'
    )
    .forEach(row => {
      row.classList.toggle(
        'is-overflowing',
        row.scrollWidth > row.clientWidth + 1
      );
    });
};


   
  if (!input || !results || !searchContent) return;

  const searchForm =
    input.closest('form');

  const searchValueInput =
    searchForm?.querySelector('#SearchInputValue');

  const syncSearchFormValue = () => {
    if (!searchValueInput) return;

    searchValueInput.value =
      input.value || '';
  };

  input.addEventListener(
    'input',
    syncSearchFormValue
  );

  searchForm?.addEventListener(
    'submit',
    syncSearchFormValue
  );

  let timeout;
  let closeTimeout;
  let activeRequest = 0;
  let hasGlobalClickListener = false;
  let cachedDiscoveryProducts = [];
  let cachedPredictiveServicesHtml = '';

  const getSearchDrawerCloseDelay = () => {
    const fallbackDelay = 420;
    const contentStyles =
      window.getComputedStyle(searchContent);

    const durations =
      contentStyles.transitionDuration
        .split(',')
        .map(value => value.trim())
        .filter(Boolean);

    const parsedDurations =
      durations.map(value => {
        const amount =
          Number.parseFloat(value);

        if (!Number.isFinite(amount)) return 0;

        return value.endsWith('ms')
          ? amount
          : amount * 1000;
      });

    const longestDuration =
      Math.max(0, ...parsedDurations);

    return Math.max(fallbackDelay, longestDuration + 80);
  };

  const isInlineSearchPanelViewport = () =>
    window.matchMedia('(max-width: 1023px)').matches;

  const updateInlineSearchPanelAnchor = () => {
    if (!isInlineSearchPanelViewport()) {
      document.documentElement.style.removeProperty(
        '--mystic-inline-search-panel-top'
      );

      return;
    }

    const header =
      document.querySelector('.shopify-section-header');

    if (!header) return;

    const rect =
      header.getBoundingClientRect();

    if (!rect.height) return;

    document.documentElement.style.setProperty(
      '--mystic-inline-search-panel-top',
      `${Math.max(0, Math.ceil(rect.bottom))}px`
    );
  };

  /*
=========================================
WORD ANIMATION
=========================================
*/

const words = [
  'services...',
  'hoodies...',
  'products...',
  'tees...',
  'partners...',
  'books...',
  'articles...',
  'resources...'
];

let wordIndex = 0;
let wordRotation = null;
let wordCleanup = null;

let animationWrapper =
  input.parentNode.querySelector('.search-word-animation');

if (!animationWrapper) {
  animationWrapper =
    document.createElement('div');

  animationWrapper.className =
    'search-word-animation';

  input.parentNode.appendChild(
    animationWrapper
  );
}

input.placeholder = '';
input.setAttribute('placeholder', '');

const clearWordTimers = () => {

  if (wordRotation) {
    clearInterval(wordRotation);
    wordRotation = null;
  }

  if (wordCleanup) {
    clearTimeout(wordCleanup);
    wordCleanup = null;
  }

};

const removeExtraAnimatedWords = () => {

  const animatedWords =
    animationWrapper.querySelectorAll(
      '.search-animated-word'
    );

  animatedWords.forEach((word, index) => {

    if (index < animatedWords.length - 1) {
      word.remove();
    }

  });

};

const renderSearchWord = (
  text = words[wordIndex],
  animate = false
) => {

  animationWrapper.innerHTML =
    '<span class="search-static-word">Search</span>';

  const word =
    document.createElement('span');

  word.className =
    animate
      ? 'search-animated-word pre-enter'
      : 'search-animated-word';

  word.textContent =
    text;

  animationWrapper.appendChild(word);

  if (animate) {

    requestAnimationFrame(() => {

      requestAnimationFrame(() => {

        word.classList.remove('pre-enter');

      });

    });

  }

};

const rotateWord = () => {

  if (document.hidden) return;

  if (
    category &&
    category.value &&
    category.value.trim()
  ) {

    return;

  }

  removeExtraAnimatedWords();

  const oldWord =
    animationWrapper.querySelector(
      '.search-animated-word'
    );

  if (!oldWord) {

    renderSearchWord(
      words[wordIndex],
      true
    );

    return;

  }

  oldWord.classList.add('exit');

  wordIndex =
    (wordIndex + 1) % words.length;

  const newWord =
    document.createElement('span');

  newWord.className =
    'search-animated-word pre-enter';

  newWord.textContent =
    words[wordIndex];

  animationWrapper.appendChild(newWord);

  requestAnimationFrame(() => {

    requestAnimationFrame(() => {

      newWord.classList.remove('pre-enter');

    });

  });

  if (wordCleanup) {
    clearTimeout(wordCleanup);
  }

  wordCleanup =
    setTimeout(() => {

      animationWrapper
        .querySelectorAll(
          '.search-animated-word.exit'
        )
        .forEach(word => word.remove());

      removeExtraAnimatedWords();

      wordCleanup = null;

    }, 900);

};

const startWordRotation = () => {

  clearWordTimers();

  if (
    category &&
    category.value &&
    category.value.trim()
  ) {

    return;

  }

  wordRotation =
    setInterval(
      rotateWord,
      2400
    );

};

/*
Initial render.

Important:
The rotation interval starts immediately.
That keeps the first word from staying on
screen longer than the rest of the words.
*/

renderSearchWord(
  words[wordIndex],
  true
);

startWordRotation();

document.addEventListener(
  'visibilitychange',
  () => {

    clearWordTimers();

    /*
    When the tab is hidden, stop all animation
    timing so throttled browser timers cannot
    stack words in the background.
    */

    if (document.hidden) {
      return;
    }

    /*
    When returning to the tab, rebuild the
    placeholder from scratch with exactly one
    animated word.
    */

    renderSearchWord(
      words[wordIndex],
      false
    );

    startWordRotation();

  }
);

window.addEventListener(
  'pagehide',
  () => {

    clearWordTimers();

  }
);

window.addEventListener(
  'pageshow',
  () => {

    clearWordTimers();

    renderSearchWord(
      words[wordIndex],
      false
    );

    startWordRotation();

  }
);



  /*
=========================================
DISCOVERY PRODUCTS
=========================================
*/

const getDiscoveryProducts = async () => {

  if (cachedDiscoveryProducts.length) {

    return cachedDiscoveryProducts;

  }

  try {

    const discoveryQueries = [
  'a',
  'b',
  'c',
  'd',
  'e',
  'm',
  'n',
  'r',
  's',
  't'
];

const randomQuery =
  discoveryQueries[
    Math.floor(
      Math.random() *
      discoveryQueries.length
    )
  ];

const response =
  await fetch(
    `/search/suggest?q=${encodeURIComponent(randomQuery)}&resources[type]=product&resources[limit]=50&section_id=predictive-search`
  );

    if (!response.ok) {

      return [];

    }

    const text =
      await response.text();

    const parser =
      new DOMParser();

    const doc =
      parser.parseFromString(
        text,
        'text/html'
      );

    const cards = [

      ...doc.querySelectorAll(
        '.predictive-result-card'
      )

    ];

const filteredCards = cards;

    /*
    =========================================
    RANDOMIZE
    =========================================
    */

    const shuffled =
      filteredCards.sort(
        () => 0.5 - Math.random()
      );

    cachedDiscoveryProducts =
      shuffled.slice(0, 20);

    return cachedDiscoveryProducts;

  } catch(err) {

    console.error(
      'Discovery products failed:',
      err
    );

    return [];

  }

};

const getPredictiveServicesHtml = async () => {

  if (cachedPredictiveServicesHtml) {

    return cachedPredictiveServicesHtml;

  }

  try {

    const response =
      await fetch('/?section_id=predictive-services-carousel');

    if (!response.ok) {

      return '';

    }

    const html =
      await response.text();

    const parser =
      new DOMParser();

    const doc =
      parser.parseFromString(
        html,
        'text/html'
      );

    const section =
      doc.querySelector(
        '.predictive-search-services-section'
      );

    cachedPredictiveServicesHtml =
      section?.outerHTML || '';

    return cachedPredictiveServicesHtml;

  } catch (err) {

    console.error(
      'Predictive services failed:',
      err
    );

    return '';

  }

};


  /*
  =========================================
  DISCOVERY STATE
  =========================================
  */


  const renderDiscoveryState = async () => {

  const suggestionsTemplate =
  document.querySelector(
    '#SearchSuggestionsTemplate .predictive-search-suggestions'
  );

const suggestionsHtml =
  suggestionsTemplate?.outerHTML || '';

  const [
    discoveryProducts,
    servicesHtml
  ] =
  await Promise.all([
    getDiscoveryProducts(),
    getPredictiveServicesHtml()
  ]);

const discoveryCarousel =
  discoveryProducts.length
    ? `

      <div class="predictive-search-discovery-section">

        <h5 class="predictive-search-discovery-heading">

          What's Hot Right Now

        </h5>

        <div class="predictive-search-discovery-message">

          Browse these best sellers or start typing to search products, articles, pages, and more.

        </div>

        <div class="predictive-search-discovery-carousel">

          ${discoveryProducts
            .map(card => card.outerHTML)
            .join('')}

        </div>

      </div>

    `
    : '';


  

  results.innerHTML = `

  <div class="predictive-search-discovery">

  ${suggestionsHtml}

  ${discoveryCarousel}

  <div id="PredictiveServicesMount">${servicesHtml}</div>

</div>

`;

  results
    .querySelectorAll('.search-suggestion')
    .forEach(item => {

      item.addEventListener('click', () => {

        input.value =
          item.textContent.trim();

        runPredictiveSearch();

        focusSearchInput();

      });

    });

  updateSuggestionOverflowState();

  openPredictiveSearch();

  attachGlobalClose();

};

  /*
  =========================================
  OPEN / CLOSE
  =========================================
  */

  const openPredictiveSearch = () => {

    clearTimeout(closeTimeout);

    updateInlineSearchPanelAnchor();

    searchContent.classList.remove(
      'custom-drawer-closing'
    );

    searchContent.classList.add(
      'custom-drawer-open'
    );

    const overlay =
  document.querySelector(
    'body-element.body-overlay'
  );

if (overlay) {

  overlay.style.zIndex = '';

  overlay.classList.add(
    'visible'
  );

}

    document.body.classList.add(
  'predictive-search-active'
);

    requestAnimationFrame(
      updateSuggestionOverflowState
    );



  };

  const closePredictiveSearch = (event) => {

    if (
      event &&
      wrapper &&
      wrapper.contains(event.target)
    ) {
      return;
    }

    if (
      document.documentElement.classList.contains(
        'mystic-route-handoff-active'
      )
    ) {
      clearTimeout(closeTimeout);

      searchContent.classList.remove(
        'custom-drawer-open',
        'custom-drawer-closing'
      );

      document.body.classList.remove(
        'predictive-search-active',
        'predictive-search-overlay-closing'
      );

      return;
    }

    clearTimeout(closeTimeout);

    searchContent.classList.remove(
      'custom-drawer-open'
    );

    searchContent.classList.add(
      'custom-drawer-closing'
    );

document.body.classList.remove(
  'predictive-search-active'
);

document.body.classList.add(
  'predictive-search-overlay-closing'
);

const overlay =
  document.querySelector(
    'body-element.body-overlay'
  );

if (overlay) {

  overlay.classList.remove(
    'visible'
  );

}

  

    document.removeEventListener(
      'click',
      closePredictiveSearch
    );

    hasGlobalClickListener = false;

    closeTimeout = setTimeout(() => {

      searchContent.classList.remove(
        'custom-drawer-closing'
      );

      if (
        !document.body.classList.contains(
          'is-navigating-search'
        )
      ) {

        results.innerHTML = '';

      }

      document.body.classList.remove(
  'predictive-search-overlay-closing'
);

    }, getSearchDrawerCloseDelay());

  };

  const attachGlobalClose = () => {

    if (hasGlobalClickListener) return;

    hasGlobalClickListener = true;

    setTimeout(() => {

      document.addEventListener(
        'click',
        closePredictiveSearch
      );

    }, 50);

  };

  if (closeButton) {

    closeButton.addEventListener(
      'click',
      event => {

        event.preventDefault();
        event.stopPropagation();

        closeCategoryDropdown();

        closePredictiveSearch();

      }
    );

  }

  /*
  =========================================
  EMPTY STATE
  =========================================
  */

  function renderEmptyState(query) {

   const suggestionsTemplate =
  document.querySelector(
    '#SearchSuggestionsTemplate .predictive-search-suggestions'
  );

const popularLinks =
  suggestionsTemplate?.outerHTML || '';

    results.innerHTML = `
      <div class="predictive-search-results-wrapper fallback-empty">

        <div class="predictive-search-empty">

          <h3>
            No results found for "${escapeHtml(query)}"
          </h3>

          <p>
            Try another keyword or explore a popular search below.
          </p>

          
            ${popularLinks}
          

        </div>

      </div>
    `;

    results
      .querySelectorAll(
        '.search-suggestion'
      )
      .forEach(button => {

        button.addEventListener('click', () => {

          input.value =
            button.textContent.trim();

          runPredictiveSearch();

          focusSearchInput();

        });

      });

    updateSuggestionOverflowState();

    openPredictiveSearch();

    attachGlobalClose();

  }

  /*
  =========================================
  ESCAPE HTML
  =========================================
  */

  function escapeHtml(str) {

    return str
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

  }

  /*
=========================================
COLLECTION SEARCH RULES
=========================================
*/

const normalizeHandle = value => {

  return String(value || '')
    .toLowerCase()
    .trim();

};

const cardBelongsToCollection = (
  card,
  handle
) => {

  const selected =
    normalizeHandle(handle);

  if (!selected) return true;

  const collectionData =
    (card.dataset.collections || '')
      .toLowerCase()
      .replace(/\s+/g, '');

  const tagData =
    (card.dataset.tags || '')
      .toLowerCase()
      .replace(/\s+/g, '');

  const raw =
    card.outerHTML
      .toLowerCase()
      .replace(/\s+/g, '');

  return (
    collectionData.includes(selected) ||
    tagData.includes(selected) ||
    raw.includes(`/collections/${selected}`) ||
    raw.includes(selected)
  );

};

const buildViewAllUrl = (
  query,
  selected
) => {

  const cleanQuery =
    encodeURIComponent(query || '');

  const selectedHandle =
    normalizeHandle(selected);

  if (selectedHandle) {

    return `/collections/${selectedHandle}?q=${cleanQuery}&handoff=1`;

  }

  return `${window.Shopify?.routes?.search_url || '/search'}?q=${cleanQuery}&options%5Bprefix%5D=last&handoff=1`;

};

/*
=========================================
RECENTLY VIEWED DISCOVERY
- No network fetches
- Saves product page visits
- Renders instantly from localStorage
=========================================
*/

const RECENTLY_VIEWED_STORAGE_KEY =
  'MysticRecentlyViewedProducts';

const RECENTLY_VIEWED_LIMIT =
  20;

const normalizeRecentlyViewedUrl = url => {

  const value =
    String(url || '').trim();

  if (!value) return '';

  if (value.startsWith('http')) {

    return value;

  }

  if (value.startsWith('//')) {

    return `${window.location.protocol}${value}`;

  }

  return value;

};

const getRecentlyViewedProducts = (
  limit = 8
) => {

  try {

    const raw =
      localStorage.getItem(
        RECENTLY_VIEWED_STORAGE_KEY
      );

    if (!raw) return [];

    const parsed =
      JSON.parse(raw);

    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter(item =>
        item &&
        item.handle &&
        item.title &&
        item.url
      )
      .slice(
        0,
        limit
      );

  } catch(err) {

    return [];

  }

};

const saveCurrentProductToRecentlyViewed = () => {

  const script =
    document.querySelector(
      '#HeaderSearchCurrentProductData'
    );

  if (!script) return;

  try {

    const product =
      JSON.parse(
        script.textContent || '{}'
      );

    if (
      !product.handle ||
      !product.title ||
      !product.url
    ) return;

    product.image =
      normalizeRecentlyViewedUrl(
        product.image
      );

    const existing =
      getRecentlyViewedProducts(
        RECENTLY_VIEWED_LIMIT
      );

    const next = [
      product,
      ...existing.filter(item =>
        item.handle !== product.handle
      )
    ].slice(
      0,
      RECENTLY_VIEWED_LIMIT
    );

    localStorage.setItem(
      RECENTLY_VIEWED_STORAGE_KEY,
      JSON.stringify(next)
    );

  } catch(err) {}

};

const getRecentlyViewedDiscoverySection = (
  limit = 8
) => {

  const products =
    getRecentlyViewedProducts(
      limit
    );

  if (!products.length) {

    return '';

  }

  return `
    <div class="predictive-search-discovery-section predictive-search-recently-viewed-section">

      <h5 class="predictive-search-discovery-heading">
        Recently Viewed
      </h5>

      <div class="predictive-search-discovery-carousel predictive-search-recently-viewed-carousel">

        ${products
          .map(product => `
            <div class="predictive-search-recently-viewed-card">

              <a
                href="${escapeHtml(product.url)}"
                class="predictive-result-card"
              >

                <div class="predictive-result-card__image">
                  ${
                    product.image
                      ? `<img src="${escapeHtml(product.image)}" alt="${escapeHtml(product.title)}" loading="lazy">`
                      : ''
                  }
                </div>

                <div class="predictive-result-card__info">

                  <div class="predictive-result-card__title">
                    ${escapeHtml(product.title)}
                  </div>

                  ${
                    product.price
                      ? `
                        <div class="predictive-result-card__price">
                          ${escapeHtml(product.price)}
                        </div>
                      `
                      : ''
                  }

                </div>

              </a>

            </div>
          `)
          .join('')}

      </div>

    </div>
  `;

};

saveCurrentProductToRecentlyViewed();

 /*
=========================================
COLLECTION DISCOVERY / COLLECTION SEARCH
=========================================
*/

const getCollectionTemplateCards = selected => {

  const selectedHandle =
    normalizeHandle(selected);

  const templates = [
    ...document.querySelectorAll(
      '#HeaderSearchCollectionTemplates template[data-collection-handle]'
    )
  ];

  const template =
    templates.find(item =>
      normalizeHandle(
        item.dataset.collectionHandle
      ) === selectedHandle
    );

  if (!template) {

    return [];

  }

  const holder =
    document.createElement('div');

  holder.innerHTML =
    template.innerHTML;

  const seen =
    new Set();

  return [
    ...holder.querySelectorAll(
      '.predictive-result-card'
    )
  ].filter(card => {

    const key =
      card.dataset.productHandle ||
      card.getAttribute('href') ||
      card.textContent.trim();

    if (seen.has(key)) {

      return false;

    }

    seen.add(key);

    return true;

  });

};

const renderCollectionMode = (
  selected,
  query = ''
) => {

  const selectedHandle =
    normalizeHandle(selected);

  const selectedOption =
    category?.options[
      category.selectedIndex
    ];

  const selectedLabel =
    selectedOption?.textContent?.trim() ||
    selected;

  const cleanQuery =
    query
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  const queryWords =
    cleanQuery
      ? cleanQuery.split(' ')
      : [];

  const cards =
    getCollectionTemplateCards(
      selected
    );

  const matchingCards =
    cards.filter(card => {

      if (!queryWords.length) {

        return true;

      }

      const searchable =
        (
          card.dataset.searchText ||
          card.textContent ||
          ''
        )
          .toLowerCase()
          .replace(/\s+/g, ' ')
          .trim();

      return queryWords.every(word =>
        searchable.includes(word)
      );

    });

  const displayCards =
    cleanQuery
      ? matchingCards
      : [...matchingCards].sort(
          () => 0.5 - Math.random()
        );

  const visibleCards =
    displayCards.slice(
      0,
      10
    );

  const collectionUrl =
    `/collections/${selectedHandle}`;

  const viewAllUrl =
    cleanQuery
      ? buildViewAllUrl(
          query,
          selected
        )
      : collectionUrl;

  if (!visibleCards.length) {

    results.innerHTML = `
      <div class="predictive-search-results-wrapper fallback-empty">

        <div class="predictive-search-empty">

          <h3>
            ${
              cleanQuery
                ? `No results found in ${escapeHtml(selectedLabel)} for "${escapeHtml(query)}"`
                : `No featured items found in ${escapeHtml(selectedLabel)}`
            }
          </h3>

          <p>
            ${
              cleanQuery
                ? `Try another keyword or view the full ${escapeHtml(selectedLabel)} collection.`
                : `Start typing to search inside this collection.`
            }
          </p>

        </div>

        <div class="predictive-search-view-all">
          <a
            href="${collectionUrl}"
            class="predictive-search__view-all-link">
            View all ${escapeHtml(selectedLabel)} →
          </a>
        </div>

      </div>
    `;

  } else {

    const heading =
      cleanQuery
        ? `Results in ${escapeHtml(selectedLabel)}`
        : `Trending ${escapeHtml(selectedLabel)}`;

    const footerText =
      cleanQuery
        ? `See all results in ${escapeHtml(selectedLabel)} for "${escapeHtml(query)}" →`
        : `View all ${escapeHtml(selectedLabel)} →`;

    if (cleanQuery) {

      results.innerHTML = `
        <div class="predictive-search-results-wrapper">

          <div class="predictive-search-results-grid">

            ${visibleCards
              .map(card => card.outerHTML)
              .join('')}

          </div>

          <div class="predictive-search-view-all">
            <a
              href="${viewAllUrl}"
              class="predictive-search__view-all-link">
              ${footerText}
            </a>
          </div>

        </div>
      `;

    } else {

      results.innerHTML = `
        <div
          class="predictive-search-results-wrapper predictive-search-results-wrapper--collection"
          data-collection-discovery="${escapeHtml(selectedHandle)}"
        >

        <div class="predictive-search-discovery predictive-search-discovery--collection">

          <div class="predictive-search-discovery-section">

            <h5 class="predictive-search-discovery-heading">
              ${heading}
            </h5>

            <div class="predictive-search-discovery-carousel">

              ${visibleCards
                .map(card => card.outerHTML)
                .join('')}

            </div>

          </div>

        </div>

        <div class="predictive-search-view-all">
          <a
            href="${viewAllUrl}"
            class="predictive-search__view-all-link">
            ${footerText}
          </a>
        </div>

      </div>
    `;

    }

  }

  searchContent.style.overflow =
    'hidden';

  results.style.overflowY =
    'auto';

  results.style.webkitOverflowScrolling =
    'touch';

  results.style.maxHeight =
    'calc(85vh - 120px)';

  const collectionWrapper =
    results.querySelector(
      '.predictive-search-results-wrapper--collection'
    );

  if (collectionWrapper) {

    collectionWrapper.style.minHeight =
      '100%';

  }

  const resultsGrid =
    results.querySelector(
      '.predictive-search-results-grid'
    );

  if (resultsGrid) {

    resultsGrid.style.minWidth =
      '0';

  }

  const footerLink =
    results.querySelector(
      '.predictive-search-view-all a'
    );

  if (footerLink) {

    footerLink.addEventListener(
      'click',
      e => {

        e.preventDefault();

        document.body.classList.add(
          'is-navigating-search'
        );

        searchContent.classList.remove(
          'custom-drawer-open'
        );

        searchContent.classList.add(
          'custom-drawer-closing'
        );

        startMysticRouteBar();

        setTimeout(() => {

          document.body.classList.remove(
            'is-navigating-search'
          );

          window.location.href =
            footerLink.getAttribute('href');

        }, 220);

      }
    );

  }

  updateSuggestionOverflowState();

  openPredictiveSearch();

  attachGlobalClose();

};

const runCollectionDiscovery = async (
  selected
) => {

  renderCollectionMode(
    selected,
    ''
  );

};


  /*
  =========================================
  MAIN SEARCH
  =========================================
  */

 const runPredictiveSearch = () => {

  clearTimeout(timeout);

  const query =
    input.value.trim();

  if (query.length < 1) {

    activeRequest++;

    const selected =
      category?.value || '';

    if (selected && selected !== '') {

      runCollectionDiscovery(
        selected
      );

    } else {

      renderDiscoveryState();

    }

    return;

  }

  const selectedForCollectionSearch =
    category?.value?.trim() || '';

  if (selectedForCollectionSearch) {

    timeout =
      setTimeout(() => {

        activeRequest++;

        renderCollectionMode(
          selectedForCollectionSearch,
          query
        );

      }, 180);

    return;

  }

    timeout = setTimeout(async () => {

      const requestId =
        ++activeRequest;

      try {

        const selected =
          category?.value || '';

        const nativeTypes = [
          '',
          'article',
          'page'
        ];

        const isCustomCollection =
          !nativeTypes.includes(selected);

        const url =
          `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product&resources[options][fields]=title,tag&resources[limit]=50&section_id=predictive-search`;

        const response =
          await fetch(url);

        if (!response.ok) return;

        const text =
          await response.text();

        if (requestId !== activeRequest) return;

        const parser =
          new DOMParser();

        const doc =
          parser.parseFromString(
            text,
            'text/html'
          );

        let incoming =
          doc.querySelector(
            '.predictive-search-results-wrapper'
          ) ||
          doc.querySelector(
            '[id^="shopify-section-predictive-search"]'
          ) ||
          doc.body.firstElementChild;

        if (!incoming) {

          renderEmptyState(query);

          return;

        }

        incoming
          .querySelectorAll(
            '.predictive-search__search-for-button, .predictive-search-view-all'
          )
          .forEach(el => el.remove());

        const resultCards =
          incoming.querySelectorAll(
            '.predictive-result-card'
          );

        const queryLower =
          query
            .toLowerCase()
            .replace(/\s+/g, ' ')
            .trim();

        const queryWords =
          queryLower.split(' ');


        let matchedCount = 0;

        resultCards.forEach(card => {

          const collectionData =
            (card.dataset.collections || '')
              .toLowerCase()
              .replace(/\s+/g, '');

          const tagData =
            (card.dataset.tags || '')
              .toLowerCase()
              .replace(/\s+/g, '');

          const cardHref =
            (card.getAttribute('href') || '')
              .toLowerCase();

          const productHandle =
            cardHref.split('/products/')[1] || '';

          const normalizedItemText =
            (card.textContent || '')
              .toLowerCase()
              .replace(/\s+/g, ' ')
              .trim();

          const matchesStringBehavior =
  queryWords.every(word =>

    normalizedItemText.includes(word) ||

    tagData.includes(word)

  );

          let matchesCollection = true;

          if (isCustomCollection) {

          matchesCollection =
            cardBelongsToCollection(
              card,
              selected
            );

        }

          if (

            !matchesCollection ||
            !matchesStringBehavior

          ) {

            card.style.display = 'none';
            card.remove();

          } else {

            matchedCount++;

          }

        });


        if (matchedCount === 0) {

          renderEmptyState(query);

          return;

        }

        results.innerHTML = '';

        const container =
          document.createElement('div');

        container.className =
          'predictive-search-results-wrapper';

        container.innerHTML =
          incoming.innerHTML;

        let viewAllUrl =
          buildViewAllUrl(
            query,
            selected
          );

        const selectedOption =
          category?.options[
            category.selectedIndex
          ];

        const selectedLabel =
          selectedOption?.textContent?.trim() || '';

        const footerText =
          selected
            ? `See all results in ${escapeHtml(selectedLabel)} for "${escapeHtml(query)}" →`
            : `See all results for "${escapeHtml(query)}" →`;

        const footer =
          document.createElement('div');

        footer.className =
          'predictive-search-view-all';

        footer.innerHTML = `
          <a
            href="${viewAllUrl}"
            class="predictive-search__view-all-link">
            ${footerText}
          </a>
        `;

        footer
          .querySelector('a')
          .addEventListener('click', e => {

            e.preventDefault();

            document.body.classList.add(
              'is-navigating-search'
            );

            searchContent.classList.remove(
              'custom-drawer-open'
            );

            searchContent.classList.add(
              'custom-drawer-closing'
            );

            startMysticRouteBar();

            setTimeout(() => {

              document.body.classList.remove(
                'is-navigating-search'
              );

              window.location.href =
                viewAllUrl;

            }, 220);

          });

        container.appendChild(footer);

        results.appendChild(container);

        searchContent.style.overflow =
          'hidden';

        results.style.overflowY =
          'auto';

        results.style.webkitOverflowScrolling =
          'touch';

        results.style.maxHeight =
          'calc(85vh - 120px)';

        container.style.minHeight =
          '100%';

        openPredictiveSearch();

        attachGlobalClose();

      } catch (err) {

        console.error(
          'Predictive search critical failure:',
          err
        );

      }

    }, 180);

  };


/*
=========================================
PREWARM DISCOVERY DISABLED FOR SPEED TEST
=========================================
*/

const prewarmDiscovery = () => {
  // Disabled for performance test.
};

   /*
  =========================================
  EVENTS
  =========================================
  */

  const getSelectedCategoryLabel = () => {

    const selected =
      category?.value?.trim();

    if (!selected || !category) {

      return '';

    }

    const selectedOption =
      category.options[
        category.selectedIndex
      ];

    return (
      selectedOption?.textContent?.trim() ||
      selected
    );

  };

  const renderAllPlaceholderAnimation = () => {

    animationWrapper.innerHTML =
      '<span class="search-static-word">Search</span>';

    const restoredWord =
      document.createElement('span');

    restoredWord.className =
      'search-animated-word';

    restoredWord.textContent =
      words[wordIndex];

    animationWrapper.appendChild(
      restoredWord
    );

  };

  const renderSelectedCategoryPlaceholder = () => {

    const selectedLabel =
      getSelectedCategoryLabel();

    if (!selectedLabel) {

      renderAllPlaceholderAnimation();

      return;

    }

    animationWrapper.innerHTML =
      `<span class="search-static-word">Search ${selectedLabel}</span>`;

  };

  input.addEventListener('focus', e => {

    e.stopPropagation();

    const selected =
      category?.value?.trim();

    if (selected) {

  clearWordTimers();

  renderSelectedCategoryPlaceholder();

}

    animationWrapper.style.opacity =
      '0';

    if (!input.value.trim()) {

      if (
        category &&
        category.value
      ) {

        runCollectionDiscovery(
          category.value.trim()
        );

      } else {

        renderDiscoveryState();

      }

    }

  });

  input.addEventListener('blur', () => {

    if (!input.value.trim()) {

      const selected =
        category?.value?.trim();

      if (selected) {

        renderSelectedCategoryPlaceholder();

      }

      animationWrapper.style.opacity =
        '1';

    }

  });

  const navigateHeaderSearch = () => {
  const query =
    input.value.trim();

  const selected =
    category?.value?.trim() || '';

  const url =
    selected
      ? (
          query
            ? buildViewAllUrl(query, selected)
            : `/collections/${normalizeHandle(selected)}`
        )
      : buildViewAllUrl(query, '');

  document.body.classList.add(
    'is-navigating-search'
  );

  closeCategoryDropdown();

  if (searchContent) {
    searchContent.classList.remove(
      'custom-drawer-open'
    );

    searchContent.classList.add(
      'custom-drawer-closing'
    );
  }

  if (window.MysticRouteHandoff?.navigate) {
    window.MysticRouteHandoff.navigate(url);
    return;
  }

  startMysticRouteBar();

  requestAnimationFrame(() => {
    window.location.href =
      url;
  });
};

searchForm?.addEventListener(
  'submit',
  event => {
    event.preventDefault();
    navigateHeaderSearch();
  }
);

input.addEventListener(
  'keydown',
  event => {
    if (event.key !== 'Enter') return;

    event.preventDefault();
    navigateHeaderSearch();
  }
);

  input.addEventListener(
    'input',
    () => {

      if (input.value.trim().length > 0) {

        animationWrapper.style.opacity =
          '0';

        animationWrapper.classList.add(
          'is-hidden-while-typing'
        );

      } else {

        animationWrapper.classList.remove(
          'is-hidden-while-typing'
        );

      }

      const hasQuery =
        input.value.trim().length > 0;

      const selected =
        category?.value?.trim();

      if (!hasQuery) {

        if (selected) {

          renderSelectedCategoryPlaceholder();

          animationWrapper.style.opacity =
            '1';

        } else {

          renderAllPlaceholderAnimation();

          animationWrapper.style.opacity =
            '1';

        }

      }

      runPredictiveSearch();

    }
  );

    const shouldKeepSearchOpenDuringScroll = target => {

  return !!(
    target &&
    (
      searchContent.contains(target) ||
      results.contains(target) ||
      categoryMenu?.contains(target) ||
      categoryWrap?.contains(target)
    )
  );

};

const closeSearchWhenPageScrolls = event => {

  if (
    !searchContent.classList.contains(
      'custom-drawer-open'
    )
  ) return;

  if (
    searchContent.classList.contains(
      'custom-drawer-closing'
    )
  ) return;

  if (
    shouldKeepSearchOpenDuringScroll(
      event.target
    )
  ) {

    return;

  }

  closeCategoryDropdown();

  closePredictiveSearch();

};

window.addEventListener(
  'wheel',
  closeSearchWhenPageScrolls,
  {
    capture: true,
    passive: true
  }
);

window.addEventListener(
  'touchmove',
  closeSearchWhenPageScrolls,
  {
    capture: true,
    passive: true
  }
);

window.addEventListener(
  'resize',
  () => {
    if (
        searchContent.classList.contains(
          'custom-drawer-open'
        )
      ) {
      updateInlineSearchPanelAnchor();
      updateSuggestionOverflowState();
    }
  },
  {
    passive: true
  }
);

if (window.visualViewport) {
  window.visualViewport.addEventListener(
    'resize',
    () => {
      if (
        searchContent.classList.contains(
          'custom-drawer-open'
        )
      ) {
        updateInlineSearchPanelAnchor();
        updateSuggestionOverflowState();
      }
    },
    {
      passive: true
    }
  );
}

const lockPageScrollInsideSearch = event => {

  if (
    !searchContent.classList.contains(
      'custom-drawer-open'
    )
  ) return;

  const scrollTarget =
    event.target.closest(
      '#PredictiveSearchResults, .predictive-search-results-wrapper, .predictive-search-results-grid, .predictive-search-discovery, .search__content, .search__box'
    );

  if (!scrollTarget) return;

  const scrollable =
    getSearchScrollableTarget(
      event.target
    ) || results;

  const scrollTop =
    scrollable.scrollTop;

  const scrollHeight =
    scrollable.scrollHeight;

  const height =
    scrollable.clientHeight;

  const delta =
    event.deltaY;

  const isAtTop =
    scrollTop <= 0;

  const isAtBottom =
    scrollTop + height >= scrollHeight - 1;

  if (
    (delta < 0 && isAtTop) ||
    (delta > 0 && isAtBottom)
  ) {

    event.preventDefault();

  }

  event.stopPropagation();

};

searchContent.addEventListener(
  'wheel',
  lockPageScrollInsideSearch,
  {
    passive: false
  }
);

searchContent.addEventListener(
  'click',
  event => {
    if (
      document.documentElement.classList.contains(
        'mystic-route-handoff-active'
      )
    ) return;

    const link =
      event.target.closest('a[href]');

    if (!link) return;

    if (
      !searchContent.classList.contains(
        'custom-drawer-open'
      )
    ) return;

    if (
      link.target ||
      link.hasAttribute('download') ||
      link.getAttribute('href')?.startsWith('#')
    ) return;

    closeCategoryDropdown();
    closePredictiveSearch();
  },
  true
);

let searchTouchStartY = 0;
let searchTouchStartX = 0;

const getSearchScrollableTarget = target => {

  if (!target) return null;

  const candidates = [
    target.closest(
      '.predictive-search-results-grid'
    ),
    target.closest(
      '.predictive-search-results-wrapper'
    ),
    target.closest(
      '.predictive-search-discovery'
    ),
    target.closest(
      '.predictive-search-discovery-carousel'
    ),
    target.closest(
      '.predictive-search-services-slider'
    ),
    target.closest(
      '#PredictiveSearchResults'
    ),
    results
  ].filter(Boolean);

  return candidates.find(
    element => element.scrollHeight > element.clientHeight + 1
  ) || null;

};

const getSearchHorizontalScrollableTarget = target => {

  if (!target) return null;

  const candidates = [
    target.closest(
      '.predictive-search-discovery-carousel'
    ),
    target.closest(
      '.predictive-search-services-slider'
    ),
    target.closest(
      '.predictive-search-results-wrapper'
    ),
    target.closest(
      '.predictive-search-discovery'
    )
  ].filter(Boolean);

  return candidates.find(
    element => element.scrollWidth > element.clientWidth + 1
  ) || null;

};

searchContent.addEventListener(
  'touchstart',
  event => {

    if (
      !searchContent.classList.contains(
        'custom-drawer-open'
      )
    ) return;

    searchTouchStartY =
      event.touches?.[0]?.clientY || 0;

    searchTouchStartX =
      event.touches?.[0]?.clientX || 0;

  },
  {
    passive: true
  }
);

searchContent.addEventListener(
  'touchmove',
  event => {

    if (
      !searchContent.classList.contains(
        'custom-drawer-open'
      )
    ) return;

    const scrollable =
      getSearchScrollableTarget(
        event.target
      );

    const currentY =
      event.touches?.[0]?.clientY || 0;

    const currentX =
      event.touches?.[0]?.clientX || 0;

    const deltaY =
      searchTouchStartY - currentY;

    const deltaX =
      searchTouchStartX - currentX;

    const isHorizontalSwipe =
      Math.abs(deltaX) > Math.abs(deltaY);

    const horizontalScrollable =
      getSearchHorizontalScrollableTarget(
        event.target
      );

    if (isHorizontalSwipe && horizontalScrollable) {

      searchTouchStartY =
        currentY;

      searchTouchStartX =
        currentX;

      return;

    }

    if (!scrollable) {

      event.preventDefault();

      return;

    }

    const scrollTop =
      scrollable.scrollTop;

    const scrollHeight =
      scrollable.scrollHeight;

    const height =
      scrollable.clientHeight;

    const isAtTop =
      scrollTop <= 0;

    const isAtBottom =
      scrollTop + height >= scrollHeight - 1;

    if (
      (deltaY < 0 && isAtTop) ||
      (deltaY > 0 && isAtBottom)
    ) {

      event.preventDefault();

    }

    searchTouchStartY =
      currentY;

    searchTouchStartX =
      currentX;

  },
  {
    passive: false
  }
);

  if (category) {

  category.addEventListener(
    'change',
    () => {

      const selected =
        category.value.trim();

        clearWordTimers();

      const hasQuery =
        input.value.trim().length > 0;

      if (!selected) {

        animationWrapper.innerHTML =
          '<span class="search-static-word">Search</span>';

        const restoredWord =
          document.createElement('span');

        restoredWord.className =
          'search-animated-word';

        restoredWord.textContent =
          words[wordIndex];

        animationWrapper.appendChild(
          restoredWord
        );

        animationWrapper.style.opacity =
          hasQuery ? '0' : '1';

        if (hasQuery) {

          runPredictiveSearch();

        } else {

          renderDiscoveryState();

        }

          startWordRotation();

        return;

      }

      renderSelectedCategoryPlaceholder();

      animationWrapper.style.opacity =
        hasQuery ? '0' : '1';

      if (hasQuery) {

        runPredictiveSearch();

      } else {

        runCollectionDiscovery(
          selected
        );

      }

    }
  );

}


});
